module.exports = __webpack_public_path__ + "media/images/app/homepage/wot2-1a4dc1183d133d8b6d1918645a1264c4.webp";